/* eslint-disable import/no-anonymous-default-export */
import * as actionType from "../actions/actionType";

const initialState = {
  groupList: [],
  tableList: [],
  loading: false,
  groupLoading: false,
  editLoading: false,
  scriptContent: "",
  scriptGroupId: "",
  pageNum: 1,
  pageSize: 20,
  tableListTotal: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.SCRIPTLIBRARY_UPDATE_STATE:
      return {
        ...state,
        ...action.payload.obj,
      };
    default:
      return state;
  }
};
